module.exports = __webpack_public_path__ + "static/media/algorithmic-governance.e98bcb0b.webp";